var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#0267C1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "#9097A5",
    strokeOpacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3588 32.9583H29.6411C30.2719 32.9583 30.7838 32.4558 30.7838 31.8367L30.7836 24.7336H30.8573C31.4881 24.7336 32 24.2311 32 23.612V22.7999C32 22.1808 31.488 21.6783 30.8573 21.6783L26.3852 21.6785C25.9551 19.0092 24.022 16.9267 21.6386 16.4126C23.2114 15.9342 24.3581 14.4912 24.3581 12.7908C24.3581 10.7004 22.6257 9 20.4961 9C18.3664 9 16.634 10.7004 16.634 12.7908C16.634 14.4912 17.7808 15.9344 19.3535 16.4126C16.9699 16.9271 15.0368 19.0094 14.607 21.6785H10.1427C9.51191 21.6785 9 22.181 9 22.8001V23.6122C9 24.2313 9.51196 24.7338 10.1427 24.7338H10.2164V31.8369C10.2166 32.4517 10.7285 32.9581 11.3591 32.9581L11.3588 32.9583ZM29.9645 31.8367C29.9645 32.0137 29.8212 32.1544 29.6409 32.1544H11.3586C11.1783 32.1544 11.035 32.0137 11.035 31.8367L11.0352 24.7336H11.6822V31.1173C11.6822 31.3384 11.8665 31.5193 12.0918 31.5193H28.9076C29.1329 31.5193 29.3172 31.3384 29.3172 31.1173V24.7336H29.9642L29.9645 31.8367ZM12.5013 30.7153V24.7336H28.4981V30.7153H12.5013ZM17.4571 12.7906C17.4571 11.1424 18.8209 9.8038 20.5 9.8038C22.1792 9.8038 23.543 11.1424 23.543 12.7906C23.543 14.4387 22.1792 15.7774 20.5 15.7774C18.8209 15.7774 17.4571 14.4387 17.4571 12.7906ZM20.5 17.0919C22.9286 17.0919 25.0625 19.0455 25.5499 21.6785L15.4506 21.6787C15.9379 19.0457 18.0718 17.0919 20.5005 17.0919L20.5 17.0919ZM10.1424 23.9299C9.96214 23.9299 9.8188 23.7892 9.8188 23.6122V22.8002C9.8188 22.6232 9.96214 22.4825 10.1424 22.4825H30.8534C31.0337 22.4825 31.1771 22.6232 31.1771 22.8002V23.6122C31.1771 23.7892 31.0337 23.9299 30.8534 23.9299H10.1424Z",
    fill: "#0267C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainers);
export default __webpack_public_path__ + "static/media/trainers.4842188803cf3d7e4846c3b12528fe57.svg";
export { ForwardRef as ReactComponent };